import React from "react";
import { CVSwapLogo } from "./ClaimPage"; // Adjust the import path if needed
import { formatWithCommas } from "../services/Web3Services";
import cv_token from "../media/cv_token.png";
import { ArrowDownIcon } from "@heroicons/react/24/solid";
interface SuccessPageProps {
  account: string;
  amountDeposited: string; // The BNB amount that was successfully deposited
  claimableAmount: string; // The CVT2 amount that will be transferred
  onBack: () => void; // Function to return to the main dashboard
}

const SuccessPage: React.FC<SuccessPageProps> = ({
  account,
  amountDeposited,
  claimableAmount,
  onBack,
}) => {


  return (
    <div className="min-h-screen w-full flex items-stretch justify-center font-sora">
      <div className="w-full sm:max-w-md mx-auto">
        <div
          className="min-h-screen text-white font-sans flex flex-col p-6 relative overflow-hidden"
          style={{
            background: `radial-gradient(
        1200px 700px at top left,
         rgb(2, 36, 19),
rgb(0, 2, 5) 30%
      )`,
          }}
        >
          {/* Header */}
          <div className="flex items-center justify-between mb-12 px-2">
            <CVSwapLogo />
            <div className="bg-gray-700/50 px-3 py-1 rounded-full text-gray-300 text-sm font-mono truncate">
              {account.substring(0, 6)}...
              {account.substring(account.length - 4)}
            </div>
          </div>

          {/* Main Content */}
          <div className="flex flex-col items-center text-center text-white">
            {/* Checkmark */}
            <div className="w-24 h-24 bg-green-500 rounded-full flex items-center justify-center mb-4 shadow-lg shadow-green-500/20">
              <svg
                className="w-16 h-16 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>

            <h1 className="text-4xl font-bold mb-2">Success!</h1>

            <div className="bg-[#1A1A1A] rounded px-6 py-3 w-[85%] mt-6 mb-20 text-white flex flex-col items-center text-center shadow-lg gap-y-1">
              {/* Top Token Row */}
              <div className="flex items-center gap-3">
                <img src={cv_token} alt="CV Token" className="w-7 h-7" />
                <div className="flex flex-col">
                  <span className="text-xs text-gray-400 font-medium">
                    CVTV1
                  </span>
                  <span
                    className="text-sm font-semibold text-white"
                    title={amountDeposited}
                  >
                    {formatWithCommas(amountDeposited, 4)}
                  </span>
                </div>
              </div>

              {/* Arrow */}
              <div className="text-white w-6 h-6">
                {" "}
                <ArrowDownIcon />
              </div>

              {/* Bottom Token Row */}
              <div className="flex items-center gap-3 mb-1">
                <img src={cv_token} alt="CV Token" className="w-7 h-7" />
                <div className="flex flex-col">
                  <span className="text-xs text-gray-400 font-medium">
                    CVTV2
                  </span>
                  <span
                    className="text-sm font-semibold text-white"
                    title={amountDeposited}
                  >
                    {formatWithCommas(amountDeposited, 4)}
                  </span>
                </div>
              </div>

              {/* Gas Fee Info */}
              {/* <div className="text-sm text-white">
                Gas Fee = <span className="font-semibold">BNB </span>
              </div> */}
            </div>

            {/* Back to Home Button */}
            <button
              onClick={onBack}
              className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg"
            >
              Back to home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
